import {createSelector} from '@reduxjs/toolkit';
import type {Store} from 'store';

const x = (store: Store) => store;

export const getUpload = createSelector(x, store => store.transfers.upload);
export const getUploadWeb = createSelector(x, store => store.transfers.uploadWeb);
export const getUploadView = createSelector(x, store => store.transfers.uploadView);
export const getUploadItems = createSelector(x, store => store.transfers.uploadItems);
export const getUploadFiles = createSelector(x, store => store.transfers.uploadFiles);
export const getUploadQueue = createSelector(x, store => store.transfers.uploadQueue);
export const isUploaderMinimized = createSelector(x, store => store.transfers.uploadMinimized);

export const getDownloadBulk = createSelector(x, store => store.transfers.downloadBulk);
export const getDownloadView = createSelector(x, store => store.transfers.downloadView);
export const getDownloadItems = createSelector(x, store => store.transfers.downloadItems);
export const isDownloaderMinimized = createSelector(x, store => store.transfers.downloadMinimized);
